import { render, staticRenderFns } from "./WysiwygComponent.vue?vue&type=template&id=0c79cdfd&scoped=true"
import script from "./WysiwygComponent.vue?vue&type=script&lang=js"
export * from "./WysiwygComponent.vue?vue&type=script&lang=js"
import style0 from "./WysiwygComponent.vue?vue&type=style&index=0&id=0c79cdfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79cdfd",
  null
  
)

export default component.exports